export default __webpack_public_path__ + "static/media/MegLovelace.591bb94c.png";